import CirrusNetworkShareCard from "../../components/CirrusNetworkShareCard";

export function CirrusNetworkPage() {
  return (
    <div className="mt-12 mb-8 ml-3">
      <CirrusNetworkShareCard />
    </div>
  );
}

export default CirrusNetworkPage;
